export default "<div class=\"evisio2IframeWorkspaceApp\">\n    <div data-dojo-attach-point=\"iframeContainer\"></div>\n</div>\n"